import i18next from '../../../i18next/i18next';

const fixedTranslateFunction = i18next.getFixedT(null, 'pointOfService');

export default [
  {
    label: fixedTranslateFunction('orderStatusList.ordered'),
    value: 'ordered',
  },
  {
    label: fixedTranslateFunction('orderStatusList.preparing'),
    value: 'preparing',
  },
  { label: fixedTranslateFunction('orderStatusList.ready'), value: 'ready' },
  { label: fixedTranslateFunction('orderStatusList.out'), value: 'out' },
  {
    label: fixedTranslateFunction('orderStatusList.delivered'),
    value: 'delivered',
  },
  {
    label: fixedTranslateFunction('orderStatusList.cancelled'),
    value: 'cancelled',
  },
];
